import Vue from 'vue';
import ViewUI from 'view-design';
import VueRouter from 'vue-router';


// WEBPACK FOOTER //
// ./src/vendors.js